.splash {
	min-height: 100%;
	display: grid;
	place-items: center;
	background: var(--surface-page);
}

.mark {
	width: 4rem;
	height: 4rem;
	display: block;
	animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
	0%,
	100% {
		opacity: 0.4;
		transform: scale(0.95);
	}
	50% {
		opacity: 1;
		transform: scale(1);
	}
}
